<template>
  <div>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 pa-4">
        <v-row>
          <v-col>
            <h2>รายงานแลกคะแนนสำหรับบริจาค</h2>
          </v-col>
          <v-col class="text-right mb-4">
            <!-- <v-btn
      depressed
      color="success"
    >
      Primary
    </v-btn> -->
            <v-btn color='success' v-on="on" text-color='white' >
              <download-excel
                class="btn btn-default text-white"
                :data="itemData"
                :fields="export_fields"
                :type="exportType"
                :worksheet="exportWorksheet"
                :name="exportFileName"
                style="display: flex"
              >
                <v-icon>
                  mdi-download
                </v-icon>
                <p class="mb-0 ">Export Data</p>
              </download-excel>
            </v-btn>
          </v-col>
        </v-row>
        <!-- <v-card> -->
          <v-data-table
            :headers="headers"
            :items="itemData"
            :items-per-page="10"
          >
            <template v-slot:[`item.useDate`]="{ item }">
             {{ thaiFormattedDateHHmm(item.useDate) }}
            </template>
            <!-- <template v-slot:[`item.status`]="{ item }">
              <v-chip dark color="red">ยังไม่รับคะแนน</v-chip>
            </template>
            <template v-slot:[`item.picture`]="{ item }">
              <v-avatar color="primary" size="40">
                <img :src="item.picture" alt="img"
              /></v-avatar>
            </template> -->
          </v-data-table>
        <!-- </v-card> -->
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import moment from 'moment'
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx'
export default {
  components: {
    moment,
    downloadExcel: JsonExcel,
    XLSX
  },
  data () {
    return {
      PK: '',
      returnLink: '/Master/Package',
      session: this.$session.getAll(),
      tab: null,
      dialogPackageMember: false,
      valid: true,
      headers: [
        { text: 'สินค้าที่แลก', value: 'name' },
        { text: 'ชื่อ-นามสกุล', value: 'nameSurname' },
        { text: 'เลขผู้เสียภาษี', value: 'textPrayerNumber' },
        { text: 'อีเมลล์', value: 'email' },
        { text: 'ที่อยู่', value: 'formAddress' },
        { text: 'เบอร์โทรศัพท์', value: 'tel' },
        { text: 'วันที่แลก', value: 'useDate' }
        // { text: 'ปี', value: 'year' },
        // { text: 'คะแนน', value: 'point' },
        // { text: 'สถานะ', value: 'status' }
      ],
      itemData: [],
      export_fields: {
        'ชื่อ-นามสกุล': 'nameSurname',
        'เลขผู้เสียภาษี': 'textPrayerNumber',
        'อีเมลล์': 'email',
        'ที่อยู่': 'formAddress',
        'เบอร์โทรศัพท์': 'tel'
      },
      exportFileName: 'รายงานแลกคะแนนสำหรับบริจาค'
    }
  },
  async mounted () {
    this.getListRedeemDonationPoint()
  },
  methods: {
    async getListRedeemDonationPoint () {
      try {
        await axios.get(this.DNS_IP + '/rewardCode/getData?shopId=' + this.session.data.shopId + '&supply=บริจาค')
          .then(res => {
            if (res.data.status === false) {
              this.itemData = []
            } else {
              res.data.map(el => {
                el.nameSurname = el.preface + ' ' + el.nameSurname
                // const formAddress = ''
                el.formAddress = el.houseNumber + ' ' + 'ตำบล/แขวง' + ' ' + el.subDistrict + ' ' + 'อำเภอ/เขต' + ' ' + el.district + ' ' + 'จังหวัด' + ' ' + el.provinces + ' ' + el.postalCode
              })
              this.itemData = res.data
            }
            console.log('getListRedeemDonationPoint', res.data)
          })
      } catch (error) {
        console.log('error', error)
      }
    }

    // generateFileName () {
    //   const date = moment().format('DDMMYYYY')
    //   this.exportFileName = ` Report_Birthday_${date}.xls`
    // },
    // async getDataLogMemberOpen () {
    //   try {
    //     this.dataItem = []
    //     await axios
    //       .get(
    //         this.DNS_IP +
    //           '/Log_Birthday/get?shopId=' +
    //           this.session.data.shopId +
    //           '&status=get'
    //       )
    //       .then(res => {
    //         this.dataItem = res.data
    //         console.log('res.data', res.data)
    //         this.dataItem.map(item => {
    //           item.status = 'รับคะแนนแล้ว'
    //           item.birthDate = moment(
    //             item.birthDate
    //               .split('-')
    //               .toReversed()
    //               .join('-'),
    //             'DD-MM'
    //           )
    //             .lang('th')
    //             .format('D MMM')
    //         })
    //         console.log('this.dataItem', this.dataItem)
    //       })
    //   } catch (error) {
    //     console.log('error', error)
    //   }
    // },
    // async getDataLogMembeGet () {
    //   this.dataItem2 = []
    //   await axios
    //     .get(
    //       this.DNS_IP +
    //         '/Log_Birthday/get?shopId=' +
    //         this.session.data.shopId +
    //         '&status=open'
    //     )
    //     .then(res => {
    //       this.dataItem2 = res.data
    //       this.dataItem2.map(item => {
    //         item.status = 'ยังไม่รับคะแนน'
    //         item.birthDate = moment(
    //           item.birthDate
    //             .split('-')
    //             .toReversed()
    //             .join('-'),
    //           'DD-MM'
    //         )
    //           .lang('th')
    //           .format('D MMM')
    //       })
    //       console.log('this.dataItem2', this.dataItem2)
    //     })
    // }
  }
}
</script>
<style scoped>
h3 {
  font-size: 18.72px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Reports/ReportRedeemDonationPoints.vue